<template>
	<div ref="barShow" class="barShow">
		<ul>
			<router-link v-for="link in links" :key="link.name" :to="link.path" exact
				><li>
					<span class="point"></span><span class="section">{{ link.name }}</span>
				</li></router-link
			>
		</ul>
	</div>
</template>

<script>
import { TimelineMax } from 'gsap';

export default {
	data() {
		return {
			links: [
				{ path: '/', name: 'Home' },
				{ path: '/about', name: 'About' },
				{ path: '/skills', name: 'Skills' },
				{ path: '/projects', name: 'Projects' },
				{ path: '/contact', name: 'Contact' },
			],
			active: true,
		};
	},
	mounted() {
		const barShow = this.$refs.barShow;

		const tm = new TimelineMax();

		tm.fromTo(barShow, 1, { opacity: 0, x: -10 }, { opacity: 1, x: 0 });
	},
};
</script>

<style lang="scss" scoped>
// --------------barShow------------

a {
	transition: all 0.5s ease;
	list-style: none;
	text-decoration: none;
	list-style-type: none;
	border-bottom: none;
	transition: transform 0.2s, opacity 0.2s;
	transform: scale(0.6);
}
.barShow {
	top: 40%;
	left: 30px;
	position: fixed;

	ul {
		display: contents;
		max-width: 2px;
		opacity: 0.5;
		z-index: 99;
		text-align: center;
		padding: 0px;
		height: 100%;
		list-style-type: none;
		transition: all 0.5s ease;

		a {
			li {
				width: 15px;
				height: 15px;
				border-radius: 100%;
				text-align: center;
				background-color: #333a46;
				display: flex;
				transition: all 0.5s ease;
				margin-bottom: 25px;
				position: relative;
				cursor: pointer;

				.section {
					padding-left: 20px;
					color: aliceblue;
					font-size: 14px;
					top: 5%;
					visibility: hidden;
					transition: all 0.5s ease;
					margin-top: -3px;
					transform-origin: 100% 50%;
					transition: visibility 0.5s ease;
				}
				.point {
					position: absolute;
					width: 12px;
					height: 12px;
					border-radius: 100%;
					text-align: center;
					padding: 7.5px;
					visibility: hidden;
					margin-bottom: 25px;
					cursor: pointer;
					transition: all 0.5s ease;
					transform: scale(0.6);
				}
			}
			&:hover .point {
				display: flex;
				visibility: visible;
				background-color: #38deed;
				transition: all 0.5s ease;
			}
			&:hover .section {
				transition: all ease 0.5s;
				visibility: visible;
				-moz-transition: all ease 0.3s;
			}
		}
	}
}

.barShow ul .active li .point,
.barShow ul .exact-active li .point {
	display: flex;
	background-color: #38deed;
	transition: all 0.5s ease;
	transition: transform 0.2s, opacity 0.2s;
}
</style>
